(() => {
    function stickyATCAdev() {
        var stickyBar = document.querySelector('.sticky-atc-adev');
        const sectionId = stickyBar.dataset.sectionId;
        var mainButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);

        var cartDrawerOpen = document.querySelector('cart-drawer.drawer.active');

        var menuDrawerOpen =
            document.querySelector('header-drawer details[open]') ||
            document.querySelector('details[open] > #menu-drawer') ||
            document.querySelector('#menu-drawer')?.closest('details[open]');

        var drawerOpen = cartDrawerOpen || menuDrawerOpen;

        if (!stickyBar) return;

        if (window.innerWidth > 749 || drawerOpen) {
            stickyBar.classList.add('is-hidden');
            return;
        }

        if (!mainButton) {
            stickyBar.classList.remove('is-hidden');
            return;
        }

        var rect = mainButton.getBoundingClientRect();
        var mainButtonVisible = rect.top < window.innerHeight && rect.bottom > 0;

        stickyBar.classList.toggle('is-hidden', mainButtonVisible);
    }

    document.addEventListener('click', function(event) {
        var stickyButton = event.target.closest(`.sticky-atc-button-${sectionId}`);

        if (!stickyButton) return;

        var stickyBar = document.querySelector('.sticky-atc-adev');
        var mainButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);

        if (stickyBar) stickyBar.classList.add('is-hidden');
        if (mainButton) mainButton.click();

        setTimeout(stickyATCAdev, 100);
        setTimeout(stickyATCAdev, 300);
    });

    var cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
        var cartObserver = new MutationObserver(stickyATCAdev);

        cartObserver.observe(cartDrawer, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    var headerDrawer = document.querySelector('header-drawer');

    if (headerDrawer) {
        var menuObserver = new MutationObserver(function() {
            stickyATCAdev();
        });

        menuObserver.observe(headerDrawer, {
            attributes: true,
            subtree: true,
            attributeFilter: ['open', 'class', 'aria-expanded']
        });
    }

    window.addEventListener('scroll', stickyATCAdev);
    window.addEventListener('resize', stickyATCAdev);
    document.addEventListener('shopify:section:load', stickyATCAdev);

    document.addEventListener('click', function() {
        setTimeout(stickyATCAdev, 50);
        setTimeout(stickyATCAdev, 250);
    });

    stickyATCAdev();

})();